const CONVERSATIONS_LS_KEY  = 'sjvm_conversations';
const VENDOR_CALS_LS_KEY    = 'sjvm_vendor_calendars';
const SESSION_KEY           = 'sjvm_session_id';

// Canonical conversation ID — always the same for any two users regardless of who initiates
function getConvoId(id1, id2, eventId) { return [id1, id2].sort().join('_') + (eventId ? '_evt_' + eventId : ''); }

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    id = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export { getConvoId, getSessionId, SESSION_KEY, CONVERSATIONS_LS_KEY, VENDOR_CALS_LS_KEY };
